import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { NEW_RELIC } from './constants';


export const newRelicAgent = !NEW_RELIC.APPLICATION_ID.startsWith('{') ? new BrowserAgent({
    info: {
        applicationID: NEW_RELIC.APPLICATION_ID,
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: NEW_RELIC.API_KEY,
        sa: 1
    },
    init: {
        ajax: {
            deny_list: [
                'api2.amplitude.com',
                'bam.nr-data.net',
                'gs.amplitude.com',
                'sr-client-cfg.amplitude.com'
            ]
        },
        browser_consent_mode: {
            enabled: false
        },
        distributed_tracing: {
            enabled: true
        },
        performance: {
            capture_detail: false,
            capture_marks: false,
            capture_measures: true
        },
        privacy: {
            cookies_enabled: true
        }
    },
    loader_config: {
        accountID: 4323933,
        agentID: NEW_RELIC.APPLICATION_ID,
        applicationID: NEW_RELIC.APPLICATION_ID,
        licenseKey: NEW_RELIC.API_KEY,
        trustKey: 4323933
    }
}) : null;

export const useNewRelicAgent = () => {
    const auth0 = useAuth0();
    useEffect(() => {
        if (newRelicAgent && auth0.user?.sub && auth0.user?.email) {
            newRelicAgent.setUserId(auth0.user.sub);
            newRelicAgent.setCustomAttribute('email', auth0.user.email);
        }
    }, [auth0.user?.sub, auth0.user?.email]);
};
